export default __webpack_public_path__ + "static/media/loaders.859f3db1.gif";